import React from "react";
import { IonCard, IonCardContent, IonButton } from "@ionic/react";

import { useForm } from "react-hook-form";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router";

import { Breadcrumbs, Input } from "../../../components";

import { RESET_PASSWORD } from "../../../graphql/mutations/auth.mutation";

import toast from "react-hot-toast";

import "./login.styles.css";

const ResetPassword = () => {
  const history = useHistory();
  const [success, setSuccess] = React.useState<boolean>(true);
  const [resetPasswordMutation] = useMutation(RESET_PASSWORD, {
    onCompleted(data) {
      if (
        data.resetCustomerPassword &&
        data.resetCustomerPassword.errors &&
        data.resetCustomerPassword.errors.length > 0
      ) {
        toast.error(data.resetCustomerPassword.errors[0].message);
        setSuccess(false);
        return;
      }
      toast.success("La password è stata modificata con successo");
      history.push("/login");
    },
    onError(error) {
      if (error.message) {
        toast.error(error.message);
      }
    },
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const onFinish = (values: any) => {
    const resetToken = history?.location?.search;
    const urlParams = new URLSearchParams(resetToken);

    resetPasswordMutation({
      variables: {
        password: values.password,
        confirmPassword: values.confirmPassword,
        resetToken: urlParams.get("token"),
      },
    });
  };

  const breadcrumbEntries = [{ title: "Resetta la password" }];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />
      <div className="app-page-wrapper flex-center">
        <IonCard
          style={{
            width: "525px",
            padding: "20px",
          }}
        >
          {success ? (
            <IonCardContent>
              <p
                className="card-title-text-large mb-default"
                style={{
                  marginBottom: "20px",
                }}
              >
                Resetta la password
              </p>

              <form onSubmit={handleSubmit(onFinish)}>
                <Input
                  name="Password"
                  registerName="password"
                  register={register}
                  errors={errors}
                  requiredMessage="Campo obbligatorio"
                  type="password"
                />

                <Input
                  name="Conferma password"
                  registerName="confirmPassword"
                  register={register}
                  errors={errors}
                  requiredMessage="Campo obbligatorio"
                  type="password"
                />

                <div className="flex-justify-between">
                  <span />

                  <IonButton
                    shape="round"
                    slot="end"
                    size="default"
                    className="login-button"
                    type="submit"
                  >
                    Invia
                  </IonButton>
                </div>
              </form>
            </IonCardContent>
          ) : (
            <IonCardContent>
              <p
                className="card-title-text-large mb-default"
                style={{
                  marginBottom: "20px",
                }}
              >
                Il collegamento Reimposta password è scaduto
              </p>
              <p
                className="card-title-text-small mb-default text-center"
                style={{
                  marginBottom: "20px",
                }}
              >
                Per favore, richiedi un nuovo collegamento per {""}
                <a
                  href="/forgot-password"
                  style={{
                    textDecoration: "underline",
                    color: "#3563b9",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  reimpostare la password.
                </a>
              </p>
            </IonCardContent>
          )}
        </IonCard>
      </div>
    </div>
  );
};

export default ResetPassword;
